const containerCls = "_vccrkce5x";
const iconCls = "_vci1hyszvx";

export { containerCls, iconCls };
import "./video-component.scrambled.style.linaria.module.css";
//# sourceMappingURL=video-component.scrambled.style.js.map
